<template>
  <div class="internet_apply_detail">
    <div class="ad_title">
      <div class="txt_1">고객 가입 정보</div>
    </div>
    <div class="ad_con_wrap" v-if="isInfoView">
      <div v-if="hideInfo">
        <div class="ad_con pb bt">
          <div class="con_title">개인정보</div>
          <div class="con_txt">
            <dl class="">
              <dt class="txt_1">주소</dt>
              <dd class="txt_2">{{ item.address }} {{ item.addressDetail }}</dd>
            </dl>
          </div>
          <p class="btm_txt">
            열람권을 사용하여 고객님의 전체정보를 확인하세요.
          </p>
        </div>
      </div>
      <div v-else>
        <div class="ad_con bb pb bt">
          <div class="con_title">개인정보</div>
          <div class="con_txt">
            <dl class="mb04">
              <dt class="txt_1">이름</dt>
              <dd class="txt_2">{{ item.name }}</dd>
            </dl>
            <dl class="mb04">
              <dt class="txt_1">주민번호</dt>
              <dd class="txt_2">{{ item.residentNumber }}</dd>
            </dl>
            <dl class="mb04" v-if="isPromotionView">
              <dt class="txt_1">통신사</dt>
              <dd class="txt_2">{{ item.mobileTelecom }}</dd>
            </dl>
            <dl class="mb04">
              <dt class="txt_1">휴대폰번호</dt>
              <dd class="txt_2">{{ item.mobileNumber }}</dd>
            </dl>
            <dl class="mb04">
              <dt class="txt_1">설치주소</dt>
              <dd class="txt_2">
                {{ item.address }}
                {{ item.addressDetail }}
              </dd>
            </dl>
            <dl class="mb04">
              <dt class="txt_1">설치희망일</dt>
              <dd class="txt_2">{{ getDate(item.installDate) }}</dd>
            </dl>
            <dl v-if="item.email">
              <dt class="txt_1">이메일</dt>
              <dd class="txt_2">{{ item.email }}</dd>
            </dl>
          </div>
        </div>

        <div class="ad_con pb bt bb">
          <div class="con_title">요금납부정보(자동이체)</div>
          <div class="con_txt" v-if="item.paymentMethod == 'CARD'">
            <dl class="mb04">
              <dt class="txt_1">카드사</dt>
              <dd class="txt_2">{{ item.cardName }}</dd>
            </dl>
            <dl class="mb04">
              <dt class="txt_1">카드주</dt>
              <dd class="txt_2">{{ item.cardOwner }}</dd>
            </dl>
            <dl class="mb04">
              <dt class="txt_1">카드번호</dt>
              <dd class="txt_2">{{ item.cardNumber }}</dd>
            </dl>
            <dl class="">
              <dt class="txt_1">유효기간</dt>
              <dd class="txt_2">
                {{ item.cardMonth }}월 / {{ item.cardYear }}년
              </dd>
            </dl>
          </div>
          <div class="con_txt" v-else-if="item.paymentMethod == 'BANK'">
            <dl class="mb04">
              <dt class="txt_1">예금주명</dt>
              <dd class="txt_2">{{ item.bankOwner }}</dd>
            </dl>
            <dl class="mb04">
              <dt class="txt_1">은행명</dt>
              <dd class="txt_2">{{ item.bankName }}</dd>
            </dl>
            <dl class="">
              <dt class="txt_1">계좌번호</dt>
              <dd class="txt_2">{{ item.bankNumber }}</dd>
            </dl>
          </div>
        </div>

        <div class="ad_con pb bt" v-if="!isPromotionView">
          <div class="con_title">입금 정보(지원금수령용)</div>
          <div class="con_txt">
            <dl class="mb04">
              <dt class="txt_1">예금주명</dt>
              <dd class="txt_2">{{ item.supportBankOwner }}</dd>
            </dl>
            <dl class="mb04">
              <dt class="txt_1">은행명</dt>
              <dd class="txt_2">{{ item.supportBankName }}</dd>
            </dl>
            <dl>
              <dt class="txt_1">계좌번호</dt>
              <dd class="txt_2">{{ item.supportBankNumber }}</dd>
            </dl>
          </div>
          <p class="btm_txt">
            ※기입된 인적사항은 보름 후 비공개됩니다.
          </p>
        </div>
        <div class="ad_con pb bt" v-else>
          <div class="con_title">상품권선택</div>
          <div class="con_txt">
            <dl>
              <dt class="txt_1">상품권</dt>
              <dd class="txt_2">{{ item.giftOption }}</dd>
            </dl>
          </div>
          <p class="btm_txt">
            ※기입된 인적사항은 보름 후 비공개됩니다.
          </p>
        </div>
      </div>
    </div>
    <div class="ad_con_wrap" v-else>
      <div class="txt_blind">
        <div>고객님의 인적사항은 비공개 전환되었습니다.</div>
        <br />
        <div>내용의 확인을 원하시면</div>
        <div>고객센터로 문의를 바랍니다.</div>
      </div>
    </div>
  </div>
</template>

<script>
import * as util from '@common/lib/common/utils.js';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

import { ko as dateKo } from 'date-fns/locale';
import promotionCfg from '@common/lib/common/promotionCfg';

export default {
  name: 'component-internet-join-info',
  description: '인터넷 가입(약속)내역 컴포넌트',
  props: {
    item: Object,
    isPromotionView: {
      type: Boolean,
      default: false,
    },
    shop: Object,
    applyCreated: {
      type: String,
      default: '',
    },
    isInfoView: Boolean, // 15일 이후 비공개 처리
    hideInfo: Boolean, // 사장님 열람권 사용전 주소 확인
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    nl2br(val) {
      return String(val)
        .split('\n')
        .join('<br />');
    },
  },
  methods: {
    _toBR(str) {
      console.log('itemitemitemitem');
      console.log(this.item);
      var st = `<p class="ct">${str}</p>`;
      return util.toBR(st);
    },
    toCurrency(val) {
      return util.toCurrency(val);
    },
    getDate(installDate) {
      if (!installDate || installDate == null) {
        return '-';
      }

      const iDate = new Date(installDate);
      return format(iDate, 'yyyy.MM.dd (E)', { locale: dateKo });
    },
    getTotalPrice(item) {
      console.log('getTotalPrice');
      console.log(item);
      let telecomItem = this.getPromotionItem(item);

      let promotionInfo = promotionCfg.getPriceInfo(item.telecom, telecomItem);

      console.log(promotionInfo);
      return promotionInfo.support + promotionInfo.gift;
    },
    showDetailView() {
      var someElement = document.getElementById(`btn_detail`);
      someElement.classList.toggle('on');

      var infoSomeElement = document.getElementById(`more_info`);
      infoSomeElement.classList.toggle('on');
    },
  },
};
</script>

<style></style>
